import { useLenis } from "@/lib/motion";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { AudienceStrip } from "@/components/site/AudienceStrip";
import { Services } from "@/components/site/Services";
import { Benefits } from "@/components/site/Benefits";
import { About } from "@/components/site/About";
import { Process } from "@/components/site/Process";
import { Gallery } from "@/components/site/Gallery";
import { ServiceArea } from "@/components/site/ServiceArea";
import { Faq } from "@/components/site/Faq";
import { ContactForm } from "@/components/site/ContactForm";
import { FinalCta } from "@/components/site/FinalCta";
import { Footer } from "@/components/site/Footer";
import { WhatsAppButton } from "@/components/site/WhatsAppButton";

export default function Home() {
  useLenis();
  return (
    <>
      <a href="#leistungen" className="skip-link">Zum Inhalt springen</a>
      <Header />
      <main>
        <Hero />
        <AudienceStrip />
        <Services />
        <Benefits />
        <About />
        <Process />
        <Gallery />
        <ServiceArea />
        <Faq />
        <FinalCta />
        <ContactForm />
      </main>
      <Footer />
      <WhatsAppButton />
    </>
  );
}
